import styled from "styled-components";

export const MainFooter = styled.div`
    background-color: #232323;
    padding: 50px 0px 100px 0px;
`
export const SectionFooter = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;

    @media screen and (max-width: 480px){
        display: block;
        text-align: center;
    }
`
export const SocialFooter = styled.ul`
    padding: 0;
    margin: 0;
    margin-left: -15px;
    margin-top: 20px;
    li{
        display: inline-block;
        list-style: none;
        margin: 0px 10px;
        a{
            color: #ffffff;
        }
    }
`
export const TextParagraphFooter = styled.p`
    font-size: 14px;
    color: #ffffff;
    font-weight: 400;
`
export const ContentInfo = styled.div`
    display: flex;
    flex-direction: column;
    padding-right: 100px;
    align-items: flex-start;
    @media screen and (max-width: 480px){
    align-items: center;
        padding: 0;
    }
`
export const ContentMenus = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    
    @media screen and (max-width: 480px){
        display: block;
    }
`
export const MenuBox = styled.div`
    h4{
        font-size: 18px;
        color: #ffffff;
        font-weight: 600;
    }
    ul{
        padding: 0;
        margin: 0;
        li{
            list-style: none;
            margin: 15px 0px;
            font-size: 14px;
            color: #ffffff;
            text-decoration: none;
            a{
               font-size: 14px;
               color: #ffffff;
               text-decoration: none;
            }
        }
    }
`

export const ReclameAquiImage = styled.img`
  max-width: 180px; 
  height: auto; 
  margin-top: 20px; 
`;


export const HighlightSocialFooter = styled.div`
  margin-top: 20px; 
  display: flex; 
  align-items: center;
  gap: 50px; 
justify-content: center;

  a {
    color: #ffffff;
    font-size: 28px; /* Tamanho maior para dar destaque */
    transition: color 0.3s ease;

    &:hover {
      color: #FED15D; /* Muda a cor para amarelo ao passar o mouse */
    }
  }
`;